import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { TransportOrderIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { ShipmentTransportOrderNotificationsState } from './shipment-transport-order-notifications.state';
import {
  ShipmentTransportOrderNotificationsLoad,
  ShipmentTransportOrderNotificationsSetInitialState,
} from './shipment-transport-order-notifications.actions';
import { ShipmentTransportOrderNotificationsModel } from '../../models/shipment-transport-order-notifications.model';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderNotificationsFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderNotificationsState.getLoaded);
  transportOrderNotificationsData$: Observable<ShipmentTransportOrderNotificationsModel[]> = this.store.select(
    ShipmentTransportOrderNotificationsState.getNotifications,
  );

  constructor(private store: Store) {}

  loadAll(identifier: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderNotificationsLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderNotificationsSetInitialState());
  }
}
